// Map raw supplier product labels to a stable customer-facing display code.
// Suppliers re-label the same fuel grade across uploads (e.g. "DIESEL BS" /
// "DSL EFF BS" → "DIESEL LS" / "DSL EFF LS" — same fuel, different week's CSV).
// We collapse the BS variants to the canonical LS code so customers always see
// one consistent label.
const ALIAS = {
  "DIESEL BS": "DIESEL_LS",
  "DSL EFF BS": "DSL_EFF_LS",
  "DIESEL LS": "DIESEL_LS",
  "DSL EFF LS": "DSL_EFF_LS",
  "D BS COL": "DIESEL_DYED",
  "D LS DYED": "DIESEL_DYED",
  "DSL EFF COL": "DSL_EFF_DYED",
  "DSL EFF D": "DSL_EFF_DYED",
  // P4-PETRO-PASS-PLUS-GAS-MIDGRADE R1 (2026-09-16).
  // Petro-Pass Canada retail: "PLUS GAS" is 89-octane mid-grade
  // gasoline. Canonical GAS_MID; customer-facing display keeps the
  // grade + octane so operators never confuse it with 87-octane
  // GAS_REG or 91-octane GAS_PREM.
  "PLUS GAS": "MID (89)",
  "GAS_MID":  "MID (89)",
  "GAS_REG":  "REGULAR (87)",
  "GAS_PREM": "PREMIUM (91)",
  // P4-PETRO-PASS-GAS-OPERATOR-UI-READINESS R1 (2026-09-16).
  // Margin-family display alias — a single "GAS" margin rule applies
  // to all three gasoline transaction canonicals (GAS_REG/MID/PREM).
  // These entries surface friendly labels in the Admin Margin Rules
  // filter + list. Transaction rows continue to display their grade
  // via the individual GAS_REG / GAS_MID / GAS_PREM entries above.
  "GAS": "GAS (REG / MID / PREM)",
};

// Pipeline-only display override (operator spec 2026-02-12): the supplier
// ships raw "Diesel Co" (mapped to canonical DIESEL_DYED for pricing).
// Render it as "Diesel Co" — never "DIESEL_DYED" — anywhere a Pipeline
// transaction or margin rule is displayed. ESSO's own dyed-diesel rows
// remain "DIESEL_DYED" (they never ship "Diesel Co").
const PIPELINE_DYED_KEYS = new Set(["DIESEL CO", "DIESEL_DYED"]);

export function displayProduct(raw, network) {
  if (!raw) return "";
  const key = String(raw).trim().toUpperCase();
  if (String(network || "").toLowerCase() === "pipeline" && PIPELINE_DYED_KEYS.has(key)) {
    return "Diesel Co";
  }
  return ALIAS[key] || raw;
}
